// src/components/common/lib/imagePick.js
//
// Helpers for the product/category image picker. Extracted from IconPicker so
// they can be tested without importing that component, which pulls in
// services/api (axios ships ESM this repo's Jest config cannot parse).
//
// All three exist because the upload silently failed for a pilot tenant on
// iOS Safari: 0 of 72 products had an image and every attempt returned 422.
const EXT_TYPES = {
    jpg: 'image/jpeg', jpeg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
};

// iOS Safari can report an empty File.type for photo-library picks under
// limited access. The extension is then the only signal we have.
export function typeFromName(name) {
    const ext = String(name || '').split('.').pop().toLowerCase();
    return EXT_TYPES[ext] || '';
}

// FileReader gives a data URL; the upload needs bytes. Done synchronously
// from the already-loaded string so no second read of the (possibly stale)
// File is required.
export function dataUrlToBlob(dataUrl) {
    const [header, encoded] = String(dataUrl).split(',');
    const mime = (header.match(/:(.*?);/) || [])[1] || 'application/octet-stream';
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
    return new Blob([bytes], { type: mime });
}

// FastAPI validation errors arrive as an ARRAY of {loc,msg,...}. Rendering
// that object directly gives the user "[object Object]", which is how the
// 422 on this endpoint looked in the field.
export function readableDetail(detail, fallback) {
    if (!detail) return fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
        const msg = detail.map((d) => d?.msg).filter(Boolean).join('; ');
        return msg || fallback;
    }
    return fallback;
}
